module.exports = __webpack_public_path__ + "img/notFound2.a477f50.png";